import { combineReducers } from "redux";
import { reducer } from 'redux-form';
 
const counterReducer = (counter = 0, action) => {
    if (action.type === 'INCREMENT_COUNTER') {
        return counter + 1;
    }
    if (action.type === 'DECREMENT_COUNTER') {
        return counter - 1;
    }
    return counter;
};

const imagesReducer = (state = [], action) => {
    switch (action.type) {
        case 'IMAGES_READED':
            return action.payload.images;
        default:
            return state;
    }
};

const usersReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_USERS':
            return action.payload.users;
        default:
            return state;
    }
};

const userReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_USER':
            return action.payload.user;
        default:
            return state;
    }
};

const countriesReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_COUNTRIES':
            return action.payload.countries;
        default:
            return state;
    }
};

const statesReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_STATES':
            return action.payload.states;
        default:
            return state;
    }
};

const citiesReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_CITIES':
            return action.payload.cities;
        default:
            return state;
    }
};

const lastJobsReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_LAST_JOBS':
            return action.payload;
        default:
            return state;
    }
};

const publishedJobsReducer = (state = {}, action) => {
    switch (action.type) {
        case 'GET_PUBLISHED_JOBS':
            return action.payload;
        default:
            return state;
    }
};

const getJobReducer = (state = null, action) => {
    switch (action.type) {
        case 'GET_JOB':
            return action.payload;
        default:
            return state;
    }
};

const searchJobsParamsReducer = (state = {}, action) => {
    switch (action.type) {
        case 'PREPARE_SEARCH':
            return action.payload;
        default:
            return state;
    }
};

export default combineReducers({
    counter: counterReducer,
    images: imagesReducer,
    form: reducer,
    users: usersReducer,
    user: userReducer,
    countries: countriesReducer,
    states: statesReducer,
    cities: citiesReducer,
    lastJobs: lastJobsReducer,
    jobList: publishedJobsReducer,
    jobDetail: getJobReducer,
    searchJobsParams: searchJobsParamsReducer,
});
